
/**
 * 에러 응답
 */
export type ErrorResponseResponse = void;
